import React from 'react'
import { Container } from './GlobalStyledComp'

const Page404 = () => {
  return (
    <Container><h1>Page 404 : There is not a page!</h1></Container>
  )
}

export default Page404